import { render, staticRenderFns } from "./EditCustomer.vue?vue&type=template&id=2763e6ca&scoped=true"
import script from "./EditCustomer.vue?vue&type=script&lang=js"
export * from "./EditCustomer.vue?vue&type=script&lang=js"
import style0 from "./EditCustomer.vue?vue&type=style&index=0&id=2763e6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2763e6ca",
  null
  
)

export default component.exports